import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import withRouter from '../routes/withRouter';
import ConfirmModal from './ConfirmModal';


class HiringProcessItem extends React.Component {
  handleDelete = () => {
    const { template, deleteHiringTemplate, teamId } = this.props;
    deleteHiringTemplate(teamId, template);
  };

  render() {
    const {
      template,
      defaultTemplate,
      match: { params: { shortId } },
    } = this.props;
    return (
      <div
        key={template.id}
        className={`content-container__item content-container__flex-between-center scroll-position-${template.id}`}
      >
        <Link className="field-sets-item-link" to={`/teams/${shortId}/templates/${template.id}`}>
          {template.name}
        </Link>
        {' '}
        {template.id !== defaultTemplate && (
          <ConfirmModal
            type="icon"
            headerText="Удалить сценарий найма?"
            modalAction={this.handleDelete}
            icon="trash-alt"
          />
        )}
      </div>
    );
  }
}

HiringProcessItem.defaultProps = {
  teamId: null,
};


HiringProcessItem.propTypes = {
  template: PropTypes.object.isRequired,
  defaultTemplate: PropTypes.number.isRequired,
  deleteHiringTemplate: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  teamId: PropTypes.number,
};

export default withRouter(HiringProcessItem);
